import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.timers.js";
import { defineProps } from 'vue';
import Email from '@/api/modules/email';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
export default {
  name: 'mailEditing',
  props: {
    premiumTime: {
      modelValue: String,
      "default": ''
    }
  },
  data: function data() {
    var _this = this;
    var emailVerification = function emailVerification(rule, value, callback) {
      var _this$userInfo;
      if (value == '') {
        callback(new Error(_this.$t("email.email_address")));
        return;
      }
      if ((_this$userInfo = _this.userInfo) !== null && _this$userInfo !== void 0 && _this$userInfo.email && _this.userInfo.email.toLowerCase() == value.toLowerCase()) {
        callback(new Error(_this.$t("email.email_error")));
        return;
      }
      if (!/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(value)) {
        callback(new Error(_this.$t("email.emailError")));
      }
      callback();
    };
    var emailCodeVerification = function emailCodeVerification(rule, value, callback) {
      if (value == '') {
        callback(new Error(_this.$t('email.code_add')));
        return;
      }
      if (!/^\d{6}$/.test(value)) {
        callback(new Error(_this.$t('email.email_code_ver')));
      }
      callback();
    };
    return {
      timer: null,
      codeText: '',
      timeNumber: 180,
      getCodeStatus: false,
      userInfo: {},
      isNext: false,
      emailLoading: false,
      oldFrom: {
        emailCode: ''
      },
      from: {
        emailAddress: '',
        emailNewCode: ''
      },
      oldRules: {
        emailCode: [{
          required: true,
          validator: emailCodeVerification,
          trigger: 'blur'
        }]
      },
      rules: {
        emailAddress: [{
          required: true,
          validator: emailVerification,
          trigger: 'blur'
        }],
        emailNewCode: [{
          required: true,
          validator: emailCodeVerification,
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    signConnectCallBack8: {
      handler: function handler(to, from) {
        this.$store.commit('setSignConnectCallBack', false);
        if (to) {
          this.countDown();
        }
      },
      deep: true,
      immediate: false
    }
  },
  mounted: function mounted() {
    this.$store.commit('setConnectPosition', 11);
    this.codeText = this.$t('email.get_code');
    this.setRemain();
  },
  computed: _objectSpread({}, mapState(['signConnectCallBack8'])),
  destroyed: function destroyed() {
    if (this.timer) {
      this.clearnCountDown();
    }
  },
  methods: {
    setRemain: function setRemain() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var json, emailList;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              json = {
                bizType: 1
              };
              try {
                emailList = localStorage.getItem('emailList');
                if (emailList) {
                  _this2.userInfo = JSON.parse(emailList);
                } else {
                  _this2.userInfo = {
                    email: null,
                    myDomainsReminder: false
                  };
                }
              } catch (error) {
                //console.log(error)
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleClose: function handleClose() {
      this.$emit('handleClose');
    },
    handleLastStep: function handleLastStep() {
      this.codeText = this.$t('email.get_code');
      this.oldFrom.emailCode = '';
      this.from.emailNewCode = '';
      this.clearnCountDown();
      this.isNext = false;
    },
    handleBing: function handleBing() {
      var _this3 = this;
      var reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      var formEl = this.$refs.ruleFormRef;
      formEl.validate(function (valid) {
        if (valid) {} else {
          return false;
        }
      });
      if (!reg.test(this.from.emailAddress)) {
        return;
      }
      if (!this.from.emailNewCode) {
        return;
      }
      var data = {
        oldEmail: this.userInfo.email,
        oldEmailVerifyCode: this.oldFrom.emailCode,
        email: this.from.emailAddress,
        verifyCode: this.from.emailNewCode,
        premiumTime: this.premiumTime
      };
      if (this.emailLoading) {
        return;
      } else {
        this.emailLoading = true;
      }
      Email.setUserEmail(data).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(res) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _this3.emailLoading = false;
                _this3.$showTip(_this3.$t('email.success'));
                _this3.userInfo.email = _this3.from.emailAddress;
                _this3.$emit('endOfEdit');
              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }())["catch"](function (err) {
        _this3.emailLoading = false;
      });
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      var formEl = this.$refs.oldFrom;
      formEl.validate(function (valid) {
        if (valid) {
          var para = {
            email: _this4.userInfo.email,
            verifyCode: _this4.oldFrom.emailCode
          };
          Email.checkEmailCode(para).then(function (res) {
            if (res) {
              _this4.getCodeStatus = false;
              _this4.codeText = _this4.$t('email.get_code');
              _this4.timeNumber = 180;
              clearInterval(_this4.timer);
              _this4.isNext = true;
            }
          })["catch"](function (err) {});
        }
      });
    },
    clearnCountDown: function clearnCountDown() {
      this.codeText = this.$t('email.re_code');
      this.getCodeStatus = false;
      this.timeNumber = 180;
      clearInterval(this.timer);
      this.timer = null;
    },
    countDown: function countDown() {
      if (!localStorage.getItem('token')) {
        this.$store.commit('setConnectPosition', 11);
        this.$store.commit('setSignConnect', false);
        this.$store.commit('setSignConnect', true);
        return;
      }
      if (this.isNext) {
        if (this.from.emailAddress.toLowerCase() == this.userInfo.email.toLowerCase()) {
          return;
        }
      }
      if (this.getCodeStatus) {
        return;
      } else {
        this.getCodeStatus = true;
      }
      this.getCode();
    },
    getCode: function getCode() {
      var _this5 = this;
      var json = {
        email: this.isNext ? this.from.emailAddress : this.userInfo.email
      };
      this.timer = setInterval(function () {
        _this5.timeNumber = _this5.timeNumber - 1;
        _this5.codeText = _this5.timeNumber + 's';
        if (_this5.timeNumber <= 0) {
          _this5.codeText = _this5.$t('email.re_code');
          _this5.getCodeStatus = false;
          _this5.clearnCountDown();
          _this5.timeNumber = 180;
        }
      }, 1000);
      Email.sendEmailVerifyCode(json).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _this5.$showTip(_this5.$t('email.send_success'), 'success');
              case 1:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }())["catch"](function (err) {
        //console.log(err)
        _this5.$showTip(_this5.$t('email.email_system_err'), 'error');
        _this5.clearnCountDown();
        _this5.codeText = _this5.$t('email.get_code');
        _this5.getCodeStatus = false;
      });
    }
  }
};